/*

Auswahl für Stoffe und Farben mit Stoffmustern und Farbfeldern

-------------------------------- LEDER -------------------------------

erster Stoff: Lorem Ipsum dolor sit Amet
 ______________    ______________    ______________    ______________
| erste Farbe  |  | zweite Farbe |  | dritte Farbe |  | vierte Farbe |
|______________|  |______________|  |______________|  |______________|

zweiter Stoff: Consectetur adipiscing elit
 ______________    ______________    ______________
| erste Farbe  |  | zweite Farbe |  | dritte Farbe |
|______________|  |______________|  |______________|

----------------------------- KUNSTLEDER -----------------------------

dritter Stoff: Maecenas semper, magna
 ______________    ______________    ______________    ______________
| erste Farbe  |  | zweite Farbe |  | dritte Farbe |  | vierte Farbe |
|______________|  |______________|  |______________|  |______________|

*/

import { Trans } from '@lingui/macro'

import './RadioSwatches.css'
import {formatPrice} from "./helpers/general";

function RadioSwatches({name, options, selected, onChange, activeFilters, colorFamilies}) {

    return (
        <div className="radioSwatches " key={name}>
                {Object.keys(options).map((material, i) => (
                <section className='material' key={i}>
                    <h2><div>{material}</div></h2>
                    {Object.keys(options[material].options).map((line, j) => (
                        <div className='line' key={j}>
                            <div className="noneFound"><Trans>(keine passend zu den aktuellen Filtereinstellungen)</Trans></div>
                            <span className="name_description">
                                {line.icons ? <div className='icons'>{line.icons.map((icon, k) => (<i className={'icon ' + icon} key={k}></i>))}</div> : ''}
                                {options[material].options[line].washable ? <div className="attribute"><i className="fa fa-check"></i> <Trans>abwaschbar</Trans></div> : ''}
                                {options[material].options[line].abrasionResistant ? <div className="attribute"><i className="fa fa-check"></i> <Trans>strapazierfähig</Trans></div> : ''}
                                <h3>{options[material].options[line].name}:</h3>
                                {options[material].options[line].description ? <div className='description'>{options[material].options[line].description}</div> : ''}
                            </span>
                            <div className='colors'>
                                {Object.keys(options[material].options[line].colors).map((color, l) => (
                                    (
                                        (!activeFilters.washable || options[material].options[line].washable)
                                        &&
                                        (!activeFilters.abrasionResistant || options[material].options[line].abrasionResistant)
                                        &&
                                        (!activeFilters.color || ( colorFamilies[options[material].options[line].colors[color].colorId] && colorFamilies[options[material].options[line].colors[color].colorId].indexOf(activeFilters.color) !== -1) )
                                    ) ?
                                        <label className={'color' + (selected === options[material].options[line].colors[color].articleId ? ' checked' : '')} key={l}>
                                            <input type='radio' className='radio' name={name} value={options[material].options[line].colors[color].articleId} checked={selected === material.key} onChange={e => onChange(e.target.name, e.target.value)} />
                                            <div className='colorSwatch' style={{backgroundImage: `url("${options[material].options[line].colors[color].image}")`}}>
                                                <div className="tooltip" style={{backgroundImage: `url("${options[material].options[line].colors[color].image}")`}}></div>
                                            </div>
                                            <div className='text'>{options[material].options[line].colors[color].variant}</div>
                                            <div></div>
                                            <div className='price'>{formatPrice(options[material].options[line].colors[color].price)}</div>
                                        </label>
                                    : ''
                                ))}
                            </div>
                        </div>
                    ))}
                </section>
            ))}
        </div>
    )

}

export default RadioSwatches
